// extracted by mini-css-extract-plugin
export default {"api-keys-settings":"styles_api-keys-settings__1mATd","api-keys-settings-top-wrapper":"styles_api-keys-settings-top-wrapper__DNTIX"};